module.exports = __webpack_public_path__ + "static/media/stockhausen_folkwang_14.9f88ff38.jpg";